webpackJsonp([106120611565143],{

/***/ 1575:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"TreatmentSheetCareTeamMemberInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"careTeamRoleId","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}},{"defaultValue":null,"description":null,"name":"providerId","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-treatment-sheet-care-team-member-input-66459d6b32f8d3c09073.js